var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.hasErrors)?_c('div',{staticClass:"alert-error sticky inline"},_vm._l((_vm.validationErrors),function(error){return _c('div',{key:error},[_vm._v("\n    "+_vm._s(error)+"\n  ")])})):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }